const validate = values => {
  const errors = {}

  const DAYS = [
    { longName: "monday", shortName: "mon" },
    { longName: "tuesday", shortName: "tue" },
    { longName: "wednesday", shortName: "wed" },
    { longName: "thursday", shortName: "thu" },
    { longName: "friday", shortName: "fri" },
    { longName: "saturday", shortName: "sat" },
    { longName: "sunday", shortName: "sun" },
  ]

  if (!values?.details?.name) {
    errors.details = {
      ...errors?.details,
      name: "The name is required",
    }
  }

  if (
    values?.details?.locationText &&
    !/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i.test(
      values?.details?.locationText
    )
  ) {
    errors.details = {
      ...errors?.details,
      locationText:
        "The URL is invalid! It must include both http:// or https:// and a suffix like .com",
    }
  }

  if (!values?.details?.inAppNotes) {
    errors.details = {
      ...errors?.details,
      inAppNotes: "The label is required",
    }
  }

  if (!values?.availability?.attendees) {
    errors.availability = {
      ...errors?.availability,
      attendees: "The number of attendees is required",
    }
  } else if (parseInt(values?.availability?.attendees) < 1) {
    errors.availability = {
      ...errors?.availability,
      attendees: "The min value is 1",
    }
  }

  if (values?.payment?.paid) {
    if (!values?.payment?.price) {
      errors.payment = {
        ...errors?.payment,
        price: "The price is required",
      }
    } else if (parseFloat(values?.payment?.price) < 0.5) {
      errors.payment = {
        ...errors?.payment,
        price: "The price has to be at least 0.50$",
      }
    }
  }

  if (values?.payment?.tax && !values?.payment?.taxValue) {
    errors.payment = {
      ...errors?.payment,
      taxValue: "The tax is required",
    }
  }

  if (values?.payment?.tax && !values?.payment?.taxLabel) {
    errors.payment = {
      ...errors?.payment,
      taxLabel: "The tax label is required",
    }
  }

  if (values?.availability) {
    for (let day in DAYS) {
      if (values?.availability[`${DAYS[day].shortName}`]) {
        for (let time in values?.availability[`${DAYS[day].longName}`]) {
          const currentTime =
            values?.availability[`${DAYS[day].longName}`][time]
          const startValues = currentTime?.start?.split(":")
          const startHour = parseInt(startValues[0])
          const startMin = parseInt(startValues[1])
          const endValues = currentTime?.end?.split(":")
          const endHour = parseInt(endValues[0])
          const endMin = parseInt(endValues[1])
          if (
            startHour === 0 &&
            startMin === 0 &&
            endHour === 0 &&
            endMin === 0
          ) {
            continue
          }
          if (
            startHour === endHour &&
            (startMin === endMin || startMin > endMin)
          ) {
            errors.availability = {
              ...errors.availability,
              [`${DAYS[day].longName}`]: {
                _error: "Invalid time range",
              },
            }
          }
          if (startHour > endHour) {
            errors.availability = {
              ...errors.availability,
              [`${DAYS[day].longName}`]: {
                _error: "Invalid time range",
              },
            }
          }
        }
      }
    }
  }

  const timeDiff = (t1, t2) => {
    let diff = (t2.getTime() - t1.getTime()) / 1000
    diff = diff / 60
    return Math.abs(Math.round(diff))
  }

  if (values?.availability && values?.availability?.duration) {
    let invalidRangeIsFound = false
    let hasAvailableDay = false
    for (let day in DAYS) {
      if (values?.availability[`${DAYS[day].shortName}`]) {
        hasAvailableDay = true
        for (let time in values?.availability[`${DAYS[day].longName}`]) {
          let totalMin = 0
          const currentTime =
            values?.availability[`${DAYS[day].longName}`][time]
          const startValues = currentTime?.start?.split(":")
          const startHour = parseInt(startValues[0])
          const startMin = parseInt(startValues[1])
          const endValues = currentTime?.end?.split(":")
          const endHour = parseInt(endValues[0])
          const endMin = parseInt(endValues[1])

          if (startHour > endHour) {
            hasAvailableDay = false
            continue
          }

          if (
            startHour === 0 &&
            startMin === 0 &&
            endHour === 0 &&
            endMin === 0
          ) {
            continue
          }

          totalMin = timeDiff(
            new Date(2022, 2, 2, endHour, endMin),
            new Date(2022, 2, 2, startHour, startMin)
          )

          if (values.availability.duration > totalMin) {
            invalidRangeIsFound = true
            break
          }
        }
      }
      if (invalidRangeIsFound) {
        break
      }
    }
    if (hasAvailableDay && invalidRangeIsFound) {
      errors.availability = {
        ...errors.availability,
        duration:
          "Your weekly hours interval must be longer than the selected duration",
      }
    }
  }

  return errors
}

export default validate
